import type { AdminAccount } from '../../types'
import {
  requestAuthedJson,
  resolveTokenFromAuthHeaders,
  type LegacyAuthHeaders,
} from '../../lib/api/http'

type Translator = (key: string, params?: Record<string, string | number>) => string

export const requestPasswordChange = async ({
  authHeaders,
  input,
  t,
}: {
  authHeaders: LegacyAuthHeaders
  input: { currentPassword: string; newPassword: string; otpCode?: string; recoveryCode?: string }
  t: Translator
}) => {
  const token = resolveTokenFromAuthHeaders(authHeaders)
  const payload = await requestAuthedJson({
    token,
    path: '/admin/profile/password',
    init: {
      method: 'POST',
      headers: authHeaders(),
      body: JSON.stringify(input),
    },
    fallbackError: t('profile.toast.passwordError'),
  })
  return payload as { message?: string; account?: AdminAccount | null }
}

export const requestCurrentPasswordVerify = async ({
  authHeaders,
  currentPassword,
  t,
}: {
  authHeaders: LegacyAuthHeaders
  currentPassword: string
  t: Translator
}): Promise<boolean> => {
  const token = resolveTokenFromAuthHeaders(authHeaders)
  const payload = await requestAuthedJson({
    token,
    path: '/admin/profile/password/verify',
    init: {
      method: 'POST',
      headers: authHeaders(),
      body: JSON.stringify({ currentPassword }),
    },
    fallbackError: t('profile.security.currentPassword.verify.error'),
  })
  return (payload as { valid?: boolean })?.valid === true
}
